import React from "react";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { FormColumn, FormRow } from "components/layout";
import { required, trimNormalizer } from "validators";

import { IBANField, SwiftField } from "./fields";

type InternationalWireFieldsProps = {
	loading: boolean;
	formName: string;
	isEditable: boolean;
};

export const InternationalWireFields = ({
	loading,
	formName,
	isEditable,
}: InternationalWireFieldsProps) => {
	const selector = formValueSelector(formName);
	const formValue = useSelector(state => selector(state, "payment_info"));

	return (
		<>
			<FormRow>
				<FormColumn>
					<IBANField
						loading={loading}
						value={formValue?.international_wire?.iban}
						isEditable={isEditable}
					/>
				</FormColumn>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="Payee Name"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={[required]}
						name="payee_name"
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						readOnlyProps={{
							isEditable,
							value: formValue?.international_wire?.payee_name,
						}}
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<SwiftField
						loading={loading}
						value={formValue?.international_wire?.swift_bic}
						isEditable={isEditable}
					/>
				</FormColumn>
			</FormRow>
		</>
	);
};
